// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"84":"e941aff068b4943b","495":"d9e8e507f84661b9"}[chunkId] + ".css";
};